/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 * @author Evgeniy Naumov
 * @version 1.23.0
 * @since 1.23.0
 */

import { pageApi } from '@/main/api/page.api';
import { API_COLLECTIVE_PRODUCT_META } from '@/main/modules/app/Api';

import { ICollectiveProductsMetaResponse } from './types';

export const collectiveProductApi = pageApi.injectEndpoints({
    endpoints: (builder) => ({
        getCollectiveProductMeta: builder.query<ICollectiveProductsMetaResponse, void>({
            query: () => ({
                url: API_COLLECTIVE_PRODUCT_META,
            }),
            // Не кешировать
            keepUnusedDataFor: 0,
        }),
    }),
});

export const { useGetCollectiveProductMetaQuery } = collectiveProductApi;
